import { useContextSafe } from '@utils/useContextSafe';
import { useDebounce } from '@utils/useDebounce';
import { useCallback } from 'react';
import { useUpdateFormPresenceMutation } from '../../../../../gql';
import { uniqueClientId } from '../../../../application/apollo-client';
import { FormFillerContext } from '../FormFillerContextProvider';

export const useFieldPresenceUpdateEvents = (fieldId: number) => {
  const { submissionId } = useContextSafe(FormFillerContext);

  const { mutate: updatePresence } = useUpdateFormPresenceMutation({ onError: () => {/* prevent default error handling */ } });

  const updatePresenceDebounced = useDebounce(updatePresence, 1000);

  const onFocus = useCallback(() => {
    updatePresenceDebounced({ input: { uniqueClientId, submissionId, fieldId } });
  }, [fieldId, submissionId, updatePresenceDebounced]);

  const onBlur = useCallback(() => {
    updatePresenceDebounced({ input: { uniqueClientId, submissionId, fieldId: undefined } });
  }, [submissionId, updatePresenceDebounced]);

  return { onFocus, onBlur };
};